import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TicketsTable } from "../../components/tickets";
import { cn, Sheet, SheetContent, PageTabs, PageTabsList, PageTabsTrigger } from "@tellescope/ui";
import { SIDEBAR_TICKET_ID_KEY } from "./constants";
import { TicketDetails } from "../../components/tickets/TicketDetails";
import { TicketHeader } from "../../components/tickets/TicketHeader";
import { PageTabsHeader } from "../../components";
import { useTranslation } from "react-i18next";
import { useAppPermissionQuery } from "../../permissions";
import { useEffect } from "react";
import { useTicketsDefaultViewShallowStore } from "../../store";

export const TicketsViewsPage = () => {
  const { t } = useTranslation("tickets");
  const params = useParams();
  const viewId = params.viewId;
  const { lastSelectedViewId, setLastSelectedViewId } = useTicketsDefaultViewShallowStore(
    "lastSelectedViewId",
    "setLastSelectedViewId"
  );

  // useEffect is justified here because this store is a localStorage store that we want to sync to
  useEffect(() => {
    if (viewId && viewId !== lastSelectedViewId) {
      setLastSelectedViewId(viewId);
    }
  }, [viewId, lastSelectedViewId, setLastSelectedViewId]);
  const [searchParams, setSearchParams] = useSearchParams();
  const ticketOpenInSidebar = searchParams.get(SIDEBAR_TICKET_ID_KEY);
  const navigate = useNavigate();
  const {
    read: { access: canViewQueues },
  } = useAppPermissionQuery({
    model: "ticket_queues",
    actions: ["read"],
  });

  return (
    <>
      <PageTabsHeader>
        <PageTabs value="views" className="h-full">
          <PageTabsList>
            <PageTabsTrigger value="views">{t("Tickets")}</PageTabsTrigger>
            {canViewQueues && (
              <PageTabsTrigger asChild value="ticket-queues">
                <Link to="/tickets/queues">{t("Ticket Queues")}</Link>
              </PageTabsTrigger>
            )}
          </PageTabsList>
        </PageTabs>
      </PageTabsHeader>
      <div className="p-6">
        <TicketsTable
          viewId={viewId}
          onRowClick={({ id }) => {
            navigate(`/tickets/details/${id}`);
          }}
        />
      </div>
      <Sheet
        open={!!ticketOpenInSidebar}
        onOpenChange={(open) => {
          if (!open) {
            setSearchParams((prev) => {
              const prevCopy = new URLSearchParams(prev);
              prevCopy.delete(SIDEBAR_TICKET_ID_KEY);
              return prevCopy;
            });
          }
        }}
      >
        <SheetContent className="w-[80%] sm:max-w-[600px]">
          <div className={cn("relative w-full h-full", ticketOpenInSidebar ? "opacity-100" : "opacity-0")}>
            <TicketHeader
              ticketId={ticketOpenInSidebar ?? ""}
              className="px-6 pt-3 text-lg font-bold w-full text-wrap"
            />
            <TicketDetails ticketId={ticketOpenInSidebar ?? ""} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
